import { frameInfo } from '../main/frameInfo-sidecar'
import { layers } from '../main/layers-sidecar'
import { spriteMap } from '../main/spriteMap-sidecar'
import { ITileMapShip } from '../tiles/tileMapShip'
import { IModelSpot, IOxygenModel } from './oxygenModel'
import { oxygenModel } from './oxygenModel-sidecar'
import { l } from '../lib/imports'

export interface IModelTile {
  i: number
  j: number
  spot: IModelSpot
  image: Phaser.GameObjects.Image
}

export interface IModelRenderer {
  width: number
  height: number
  tiles: IModelTile[]
}

const frameGrid = frameInfo.fi32(5, 1, 13)

export function createModelTile(
  i: number,
  j: number,
  spot: IModelSpot,
): IModelTile {
  let tileSize = 8 * 4

  let image = spriteMap.createImageFromFrameInfo(
    layers.getLayers().gasses,
    frameGrid,
    i * tileSize,
    j * tileSize,
  )
  return {
    i,
    j,
    spot,
    image,
  }
}

export function createRenderer(model: IOxygenModel): IModelRenderer {
  let obj: IModelRenderer = {
    tiles: [],
    width: model.width,
    height: model.height,
  }

  for (let j = 0; j < obj.height; j++) {
    for (let i = 0; i < obj.width; i++) {
      let t = createModelTile(i, j, oxygenModel.getTileUnsafe(model, i, j))
      obj.tiles.push(t)
      // tiles.setFloor(t, dataListFloor[0])
    }
  }

  return obj
}

export function inRange(tileMap: ITileMapShip, tx: number, ty: number) {
  if (tx >= 0 && tx < tileMap.width) {
    if (ty >= 0 && ty < tileMap.height) {
      return true
    }
  }
  return false
}

export function update(obj: IModelRenderer, model: IOxygenModel) {
  if (!layers.getLayers().gasses.visible) {
    // Don't waste time udpating if not viz
    return
  }

  for (let i = 0; i < model.spots.length; i++) {
    let s = model.spots[i]
    let t = obj.tiles[i]

    t.image.visible = !s.isSpace && !s.isHull

    let red = 0
    let green = 0
    if (s.o2 < 33) {
      red = (33 - s.o2) / 33
    } else {
      green = s.o2 / 100
    }
    // red = (100 - s.o2) / 100

    // if (s.o2 < 33) {

    // } else {
    //   green = 1
    // }

    t.image.tint =
      Math.round(red * 255) * 0x010000 + Math.round(green * 255) * 0x000100

    //t.image.alpha = s.o2 / 100
  }
}
